import React, { useState } from 'react';
import { useTable, usePagination } from 'react-table';
import { CARS } from '../../constants/columns';
import { useOutletContext, useParams } from 'react-router-dom';

// components
import EmptyData from '../../components/EmptyData/EmptyData';
import Loader from '../../components/Loader/Loader';

// icons
import icon from '../../brand/generated/buttonIcons/addDeal.svg';
import getDealCars from '../../api/deals/getDealCars';
import SelectCarModal from '../../components/Modals/SelectCarModal';
import addItemsToDeal from '../../api/deals/addItemsToDeal';
import getDealCard from '../../api/deals/getDealCard';
import bucketIcon from '../../brand/generated/popover/delete.svg';
import axios from '../../plugins/axios';
const popover = [{ title: 'Ð£Ð´Ð°Ð»Ð¸ÑÑ Ð°Ð²ÑÐ¾', icon: bucketIcon }];

const DealAutos = () => {
  const { id } = useParams();
  const [cars, setCars] = useState([]);
  const [equipmentsCount, updateCounters] = useOutletContext();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);

  const init = () => {
    getDealCars({ id: id })
      .then((res) => {
        let array = res.data.cars.map((item) => {
          return { ...item, itemId: item.orderId };
        });
        setCars(array);
      })
      .finally(() => setLoadingPage(false));
  };

  React.useEffect(() => {
    init();
  }, []);

  const handeSubmit = async (cars) => {
    setLoading(true);
    try {
      cars = cars.map(({ value }) => ({ value }));

      const { data } = await getDealCard({ id });

      addItemsToDeal({
        dealId: String(id),
        clientId: data?.client?.id,
        cars,
      })
        .then(() => {
          setShowModal(false);
          updateCounters();
          init();
        })
        .catch((err) => alert(err))
        .finally(() => setLoading(false));
    } catch (e) {
      setLoading(false);
    }
  };

  const table = useTable(
    {
      columns: CARS,
      data: cars,
      disableSortRemove: true,
    },
    usePagination
  );

  const handleActionPopover = async (dealIndex, actionIndex, title, itemId, type) => {
    if (type === 'cars') {
      axios
        .post('/api/crm/deals/removeItemsToDeal', {
          services: [],
          equipments: [],
          cars: [{ value: itemId }],
          dealId: id,
        })
        .then((res) => {
          window.location.href = window.location.href;
        })
        .catch((error) => {});
    }
  };

  return (
    <>
      {loadingPage ? (
        <Loader />
      ) : (
        <>
          <EmptyData
            title={`ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ð¸ (${cars.length})`}
            subtitle={'Ð­ÑÐ¾ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¿Ð¾ÐºÐ° Ð½Ðµ ÑÑÐ°ÑÑÐ²ÑÐµÑ Ð½Ð¸ Ð² Ð¾Ð´Ð½Ð¾Ð¹ ÑÐ´ÐµÐ»ÐºÐµ'}
            action={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ðº ÑÐ´ÐµÐ»ÐºÐµ'}
            icon={icon}
            popover={popover}
            deleteType={'cars'}
            handleActionPopover={handleActionPopover}
            table={table}
            data={cars}
            func={() => setShowModal(true)}
          />
          <SelectCarModal
            isOpen={showModal}
            onClose={() => setShowModal(false)}
            onSubmit={handeSubmit}
            dealId={id}
            loading={loading}
          />
        </>
      )}
    </>
  );
};

export default DealAutos;
